import { render, staticRenderFns } from "./CdbCustomerBasic.vue?vue&type=template&id=de141ad2&scoped=true&"
import script from "./CdbCustomerBasic.vue?vue&type=script&lang=js&"
export * from "./CdbCustomerBasic.vue?vue&type=script&lang=js&"
import style0 from "./CdbCustomerBasic.vue?vue&type=style&index=0&id=de141ad2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de141ad2",
  null
  
)

export default component.exports